export default "__VITE_ASSET__BzbKe0lB__"